export const ContributionAmount = {
    "id": "54e00170-1c68-aca2-ee76-7fdefac9611c",
    "webhook": "https://d471-2600-100e-b155-77a4-ca0-fcb5-bf9-45ac.ngrok.io",
    "run": {
        "stress": true,
        "stresssolvefor": "Contribution_Amount",
        "illustration": true,
        "comparison": true,
        "reports": false,
        "deathbenefitonly": true
    },
    "common": {
        "monthlypayclientextra": 0.05,
        "paymentfrequency": "Annual",
        "verbose": false,
        "productcode": "941",
        "fullname": "John Doe",
        "agent": {
            "fullname": "Rao Garuda",
            "phoneareacode": "800",
            "phonedialnumber": "2949940",
            "addressline1": "5850 Granite Parkway",
            "addressline2": "Ste. 800",
            "addresscity": "Plano",
            "addressstate": "TX",
            "zip": "75024"
        },
        "reportsalessummaryage": 90,
        "reportlowpointduration": 18,
        "incomeagefrom": 65,
        "incomeageto": 90,
        "trustfee": 1350,
        "pensionunderwriting": "Multi-Life",
        "issueage": 37,
        "gender": "Male",
        "rateclass": "Elite_NT",
        "dateofbirth": "04/11/1985",
        "funddateilia": "07/13/2022",
        "tranchenumber": "47",
        "carrier": "NLG",
        "blendpercentage": [
            {
                "agefrom": 18,
                "ageto": 35,
                "blend": 0.1
            },
            {
                "agefrom": 36,
                "ageto": 39,
                "blend": 0.15
            },
            {
                "agefrom": 40,
                "ageto": 44,
                "blend": 0.2
            },
            {
                "agefrom": 45,
                "ageto": 49,
                "blend": 0.3
            },
            {
                "agefrom": 50,
                "ageto": 54,
                "blend": 0.4
            },
            {
                "agefrom": 55,
                "ageto": 100,
                "blend": 0.5
            }
        ],
        "illustrationissuestate": "NV",
        "contributionamount": 0,
        "totaldeathbenefit": 1050000,
        "distributionloanrate": 5.40,
        "growthrate": 0.0592,
        "incometaxrate": 0.37,
        "capitalgainstaxrate": 0.20,
        "statetaxrate": 0.055,
        "afrrate": 0.0335,
        "managementfee": 0.005,
        "arrangementfee": 500
    },
    "stress": {
        "mecavoidance": "Adjust_Premiums",
        "deathbenefittype": "Specify_Amount",
        "deathbenefitoption": "B_Increasing",
        "premiummode": "Annual",
        "premium": [
            {
                "type": "Guideline_Level_Premium",
                "from": "1",
                "through": "10"
            }
        ],
        "balancesheetbenefit": "Yes",
        "balancesheetbenefitpercentage": 100,
        "interestrates": [
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 0,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 0,
                "from": "1",
                "through": "5"
            },
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 5.92,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 5.92,
                "from": "6",
                "through": "7"
            },
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 0,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 0,
                "from": "8",
                "through": "8"
            },
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 5.92,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 5.92,
                "from": "9",
                "through": "9"
            },
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 0,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 0,
                "from": "10",
                "through": "12"
            },
            {
                "creditsuisseallocation": 50,
                "creditsuisserate": 5.92,
                "uspacesetterallocation": 50,
                "uspacesetterrate": 5.92,
                "from": "13",
                "through": "M"
            }
        ],
        "loanassumptions": {
            "discountcashvaluelowpoint": 0.88,
            "bankdiscountfirstyear": 0.9,
            "assumptions": [0.04, 0.04, 0.04, 0.04, 0.04, -0.0236, -0.0236, 0.04, -0.0236, 0.04, 0.04, 0.04, -0.0236, -0.0236, -0.0236, -0.0236, 0.0964, 0.0964, 0.0964, -0.0036, 0.05]
        }
    },
    "illustration": {
        "mecavoidance": "Adjust_Premiums",
        "deathbenefittype": "Specify_Amount",
        "deathbenefit": [
            {
                "faceamount": 892500,
                "additionalprotection": 157500,
                "from": "1",
                "through": "10"
            },
            {
                "faceamount": 100000,
                "additionalprotection": 0,
                "from": "11",
                "through": "M"
            }
        ],
        "deathbenefitchangeyear": "15",
        "deathbenefitoption": "B_Increasing",
        "premium": [
            {
                "type": "Guideline_Level_Premium",
                "from": "1",
                "through": "10"
            }
        ],
        "premiummode": "Annual",
        "distributionmode": "Annual",
        "distribution": [
            {
                "type": "Specify_Amount",
                "amount": 0,
                "adjustment": "0",
                "from": "15",
                "through": "15"
            },
            {
                "type": "Solve_for_Income",
                "from": "A65",
                "through": "A90"
            }
        ],
        "balancesheetbenefit": "Yes",
        "balancesheetbenefitpercentage": 100,

        "interestrates": [
            {
                "creditsuisseallocation": 50,
                "uspacesetterallocation": 50,
                "from": "1",
                "through": "M"
            }
        ],
        "loanassumptions": {
            "discountcashvaluelowpoint": 0.85,
            "bankdiscountfirstyear": 0.9,
            "assumptions": [0.04, 0.0468, 0.0446, 0.0431, 0.0424, 0.0420, 0.0419, 0.0418, 0.0418, 0.0418, 0.0417, 0.0417, 0.0417, 0.0417, 0.0417, 0.045]
        }
    },
    "comparison": {
        "mecavoidance": "Adjust_Face",
        "deathbenefitoption": "B_Increasing",
        "balancesheetbenefit": "Yes",
        "balancesheetbenefitpercentage": 100,
        "deathbenefittype": "Min_DB_Max_Cash_Value",
        "deathbenefitchangeyear": "6",
        "distributionmode": "Annual",
        "interestrates": [
            {
                "creditsuisseallocation": 50,
                "uspacesetterallocation": 50,
                "from": "1",
                "through": "M"
            }
        ],
        "premiummode": "Annual",
        "premium": [
            {
                "type": "Specify_Amount",
                "from": "1",
                "through": "5"
            }
        ]
    }
}